/**
 * Ando Connect — ``/workspace/connect`` layout.
 *
 * Pathless container that renders the <Outlet/> for its children:
 *   - ``connect.index.tsx``     → the hub (owned + shared-with-me directory)
 *   - ``connect.$spaceId.tsx``  → the Space detail (chat + resources + members)
 *
 * Without this Outlet layout, navigating to a Space would render the hub (the
 * parent) with the child invisible — the Space would never OPEN. Mirrors the
 * ``flows.tsx`` / ``flows.index.tsx`` / ``flows.$flowId.tsx`` pattern.
 */

import { Outlet, createFileRoute } from "@tanstack/react-router";

import { validateWorkspaceSearch } from "@/features/workspace-router";

export const Route = createFileRoute("/_authed/workspace/connect")({
  validateSearch: validateWorkspaceSearch,
  component: Outlet,
});
